import React, { useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectModal from './ProjectModal';
import projects from '../data/projects';

export default function ProjectList() {
	const [selected, setSelected] = useState(null);

	return (
		<section id="released-games" className="max-w-8xl px-4 py-2">
			<div className="bg-black/90 rounded-xl overflow-hidden border border-red-400/30 shadow-lg shadow-black/40">
				<div className="px-6 py-5">
					<h2 className="text-4xl font-bold text-white tracking-tight pl-2">Released Games</h2>
					<hr className="mt-2 border-t-2 border-red-400 w-[17.25rem]" />
					<p className="text-gray-400 text-base italic mt-3">Fully fleshed out projects. Released on Steam.</p>

					<div className="bg-white/5 border border-red-400/10 rounded-lg p-4 sm:p-6 mt-6">
						<div className="grid gap-6 max-w-[1200px] justify-start" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 550px))' }}>
							{projects.map((project, index) => (
								<ProjectCard
									key={index}
									project={project}
									onClick={() => setSelected(project)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>

			{selected && (<ProjectModal project={selected} onClose={() => setSelected(null)} isOpen={true} />)}
		</section>
	);
}